export function trimSlashes(str) {
    return str.replace(/^\/+|\/+$/g, '');
}